import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /charts/price-development-in-original-currency/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_PRICE_DEVELOPMENT_IN_ORIGINAL_CURRENCY = id =>
  request.get(`/charts/price-development-in-original-currency/subscriptions/${id}`)

/**
 * @description GET /charts/price-development-in-local-currency/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_PRICE_DEVELOPMENT_IN_LOCAL_CURRENCY = id =>
  request.get(`/charts/price-development-in-local-currency/subscriptions/${id}`)

/**
 * @description GET /charts/price-increase-in-percentage-in-original-currency-compared-to-average-price-increase/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_PRICE_INCREASE_IN_PERCENTAGE_IN_ORIGINAL_CURRENCY_COMPARED_TO_AVERAGE_PRICE_INCREASE = id =>
  request.get(
    `/charts/price-increase-in-percentage-in-original-currency-compared-to-average-price-increase/subscriptions/${id}`
  )

/**
 * @description GET /charts/price-development-in-local-currency-compared-to-average-price/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_PRICE_DEVELOPMENT_IN_LOCAL_CURRENCY_COMPARED_TO_AVERAGE_PRICE = id =>
  request.get(`/charts/price-development-in-local-currency-compared-to-average-price/subscriptions/${id}`)

/**
 * @description GET /charts/evaluation-ratings-current-previous-period/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_EVALUATION_RATINGS_CURRENT_PREVIOUS_PERIOD = id =>
  request.get(`/charts/evaluation-ratings-current-previous-period/subscription-periods/${id}`)

/**
 * @description GET /charts/stakeholder-responses-single-period/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_STAKEHOLDER_RESPONSES_SINGLE_PERIOD = id =>
  request.get(`/charts/stakeholder-responses-single-period/subscription-periods/${id}`)

/**
 * @description GET /charts/price-vs-forecasted-price-original-currency/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_PRICE_VS_FORECASTED_PRICE_ORIGINAL_CURRENCY = id =>
  request.get(`/charts/price-vs-forecasted-price-original-currency/subscriptions/${id}`)

/**
 * @description GET /charts/usage-development/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_USAGE_DEVELOPMENT = id =>
  request.get(`/charts/usage-development/subscriptions/${id}`)

/**
 * @description GET /charts/usage-development/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_CHART_USAGE_DEVELOPMENT = id =>
  request.get(`/charts/usage-development/subscription-periods/${id}`)

/**
 * @description GET /charts/cost-per-use-in-original-currency/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_COST_PER_USE_IN_ORIGINAL_CURRENCY = id =>
  request.get(`/charts/cost-per-use-in-original-currency/subscriptions/${id}`)

/**
 * @description GET /charts/cost-per-use-in-local-currency/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTION_CHART_COST_PER_USE_IN_LOCAL_CURRENCY = id =>
  request.get(`/charts/cost-per-use-in-local-currency/subscriptions/${id}`)

/**
 * @description GET /charts/share-per-{entity}?year={year}
 * @returns {AxiosPromise<any>}
 */
export const GET_SHARE_PER_ENTITY_CHART = (entity, year) => request.get(`/charts/share-per-${entity}?year=${year}`)
